<template>
  <span>
    {{ new Date(value).toLocaleDateString() }}
  </span>
</template>

<script setup>
import { defineProps } from 'vue'
defineProps({
  value: {
    type: String,
    required: true,
  },
})
</script>
